import React, { Component, Fragment } from 'react';
import SimpleLayout from '../SimpleLayout';

export class FourZeroFour extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="main__container simple-layout">
                <nav className="builder-desktop-navbar builder-navbar navbar navbar-default">
                    <div className="container-fluid">
                        <div className="navbar-header">
                            <div className="mt20 ml10 displayflex aligncenter width100 logo">
                                <img src="https://teamsly-cdn-cuc0cvgwakbtarf9.z01.azurefd.net/images/teamsly-logo-35.png" className=" mr10" style={{ height: 24 }} />
                            </div>
                        </div>
                    </div>
                </nav>
                <section className="app-builder__body height100">
                    <div className="app-style-page app-builder-page layout displayflex aligncenter flexcolumn">
                        <div class="displayflex mt40 aligncenter flexcolumn justifycenter" style={{ maxWidth: 600, height: '80%' }}>
                            <img className="my30" style={{ width: 500 }} src="https://teamsly-cdn-cuc0cvgwakbtarf9.z01.azurefd.net/images/404.png" />
                            <div class="head-m mt40">We can't seem to find the page you're looking for.</div>
                            <div class="subhead-m mt20 mb30 textcenter">
                                Sometimes this happens if you have a bad link, a typo, or we've removed the page.
                    </div>
                           
                        </div>

                    </div>
                </section>
                <style>
                    {`
                .sidebar{display:none;}
                `}
                </style>
            </div>

        );
    }
}


export default FourZeroFour;



